module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am757-f61d5320df15a4261080612a936dbe6d.jpg";